import React from 'react';
import { SvgIcon } from 'seduo-ui';
const Example = () => (<section className="mb-9 mb-lg-0 shadow-uniform card">
        <div className="d-flex justify-content-center align-items-center border-bottom py-6">
            <SvgIcon kind="LogoBrandExample" height={50} width={134}/>
        </div>
        <div className="card-body">
            <div>
                <div className="row mb-5">
                    <div className="col-7 col-md-3 col-lg-7">Počet lekcí:</div>
                    <div className="col-5 col-md-9 col-lg-5">
                        <strong>11</strong>
                    </div>
                </div>
                <div className="row mb-7">
                    <div className="col-7 col-md-3 col-lg-7">Celková délka videí:</div>
                    <div className="col-5 col-md-9 col-lg-5">
                        <strong>43 min</strong>
                    </div>
                </div>
                <p>Certifikát absolventa, Neomezený přístup</p>
            </div>
            <a href="#" className="btn btn-outline-primary btn-large btn-block">
                <span className="mr-5">
                    <SvgIcon kind="Play" className="icon"/>
                </span>
                Spustit kurz
            </a>
        </div>
    </section>);
export default Example;
